import { Flex, Text } from "@fluentui/react-northstar";
import moment from "moment";
import React from "react";
import styled from "styled-components";

export const DetailOffboardingArchivedCard = ({ archivedUserDetails }) => {
    const _dateNumber = moment(
        archivedUserDetails?.start_date,
        "YYYY-MM-DD"
    ).format("DD");

    const _monthyear = moment(
        archivedUserDetails?.start_date,
        "YYYY-MM-DD"
    ).format("MMM YYYY");

    const formatedDate = (date) => {
        return moment(date).format("DD/MM/YYYY");
    };

    return (
        <Card column>
            <Title content="Contrat " />
            <Flex column fill gap="gap.large">
                <Flex
                    styles={{ gap: "36px" }}
                    // space="between"
                    fill
                    vAlign="center"
                >
                    <DateWithBackground column>
                        <DateNumber content={_dateNumber} />
                        <MonthYearDate content={_monthyear} />
                    </DateWithBackground>
                    <ExperienceFlex column>
                        <EndTrialPeriod content="Ancienneté" />
                        <EndTrialPeriodDate
                            content={
                                archivedUserDetails?.seniority?.seniority_text
                            }
                        />
                    </ExperienceFlex>
                </Flex>
                <Flex styles={{ gap: "42px" }}>
                    <Flex column>
                        <EndTrialPeriod content="Fin de période d'essai" />
                        <EndTrialPeriodDate
                            content={
                                archivedUserDetails?.probationary_period_end_date
                                    ? formatedDate(
                                          archivedUserDetails?.probationary_period_end_date
                                      )
                                    : "Non renseigné"
                            }
                        />
                    </Flex>
                    <Flex column>
                        <EndTrialPeriod content="Fin de contrat" />
                        <EndTrialPeriodDate
                            content={
                                archivedUserDetails?.end_date
                                    ? formatedDate(
                                          archivedUserDetails?.end_date
                                      )
                                    : "Non renseigné"
                            }
                        />
                    </Flex>
                </Flex>
            </Flex>
        </Card>
    );
};
const ExperienceFlex = styled(Flex)`
    gap: 2px;
`;
const MonthYearDate = styled(Text)`
    color: #242424;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
`;

const Card = styled(Flex)`
    padding: 24px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0px 0.6px 1.8px 0px rgba(0, 0, 0, 0.11),
        0px 3.2px 7.2px 0px rgba(0, 0, 0, 0.13);
    width: 360px;
    height: 210px;
`;
const Title = styled(Text)`
    color: #242424;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    padding-bottom: 16px;
`;

const DateWithBackground = styled(Flex)`
    padding: 8px 12px;
    background: #e8ebfa;
    width: 120px;
`;
const DateNumber = styled(Text)`
    color: #4f52b2;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
`;

const EndTrialPeriod = styled(Text)`
    color: #616161;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
`;
const EndTrialPeriodDate = styled(Text)`
    color: #242424;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
`;
